<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddDealerHoliday</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>
      <form [formGroup]="addDealerHolidayForm" (ngSubmit)="onSubmit()">
        <div class=" scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <div class="col-6 af-form-group">
                  <label for="typeahead-format" translate>lblSelectDealer
                     </label>
                  <div class='lbl-info'>
                    <ng-multiselect-dropdown style="width: 25%;" formControlName="dealer"  [settings]="dropdownSettings" [data]="dealerList" placeholder="{{ 'lblSearchDealer'| translate}}" [(ngModel)]="dealerSelected">
                    </ng-multiselect-dropdown>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="name" translate>lblName
                     </label>
                  <div class='lbl-info'>
                    <input formControlName="name" class="form-control mb-2"
                      placeholder="{{ 'lblEnterName' | translate }}" required>
                  </div>
                  <div *ngIf="cpf.name.touched && (cpf.name.errors?.required)" class="help-block mt-1 text-danger"
                    translate> <em class="ft-alert-circle align-middle" aria-hidden="true" translate></em>
                    lblHolidayNameRequired
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="startDate" translate>lblStartDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'2011/01/01'"
                      required [dateTime]="false" placeholder="{{ 'lblEnterStartDate' | translate }}"
                      [disableNextMonthDates]="true" formControlName="startDate" [(ngModel)]="startDate"
                      id="txtboxStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="endDate" translate>lblEndDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker" appAfDatepicker [startDate]="'2011/01/01'"
                      placeholder="{{ 'lblEnterEndDate' | translate }}" required [dateTime]="false"
                      [disableNextMonthDates]="true" formControlName="endDate" [(ngModel)]="endDate"
                      id="txtboxStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button class="btn btn-primary mr-sm-2 btn-lg" [disabled]="!addDealerHolidayForm.valid"
                aria-label="Center Align" translate><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd</button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>